import angular from 'angular';
import { CreateUserAccountComponent } from './create-user-account.component';
import { EditUserAccountComponent } from './edit-user-account.component';
import { EditUserConnectedAccountsComponent } from './edit-user-connected-accounts.component';
import { PasswordStrengthComponent } from './password-strength.component';
import { SetUserPasswordComponent } from './set-user-password.component';

export const AccountUserModule = angular
    .module("apex.mainApp.account.user", [])
    .component("apexCreateUserAccount", CreateUserAccountComponent)
    .component("apexEditUserConnectedAccounts", EditUserConnectedAccountsComponent)
    .component("apexEditUserAccount", EditUserAccountComponent)
    .component("apexPasswordStrength", PasswordStrengthComponent)
    .component("apexSetUserPassword", SetUserPasswordComponent)
    .name;
